import { LoopOnce, LoopPingPong, LoopRepeat } from 'three';

export const animationActionLoopStylesValues = {
    LoopOnce,
    LoopRepeat,
    LoopPingPong,
};

export const animationActionLoopStylesNames: { [v: number]: AnimationActionLoopStyles } = {};
Object.keys(animationActionLoopStylesValues).forEach((k: AnimationActionLoopStyles) =>
{
    animationActionLoopStylesNames[animationActionLoopStylesValues[k]] = k;
});

export type AnimationActionLoopStyles = keyof typeof animationActionLoopStylesValues;
